import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/BasicInfoApiPaths';
import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { HadesehApiPath } from 'Feature/Hadeseh/Common/Constant/HadesehApiPath';
import {
  HavadesEnferadiHttpGetService,
  HavadesEnferadiHttpPostService,
} from 'Feature/Hadeseh/Common/Services/HavadesEnferadiHttpServices';

export const addBimehNamehEnferadiToOrder = createAsyncThunk(
  'HavadesEnferadi/addBimehNamehEnferadiToOrder',
  async (command: any) => {
    return await HavadesEnferadiHttpPostService({
      url: HadesehApiPath.BimehNamehHadesehEnferadi.AddToOrder,
      body: command,
    });
  }
);

export const bimehNamehEnferadiSaderShodeh = createAsyncThunk(
  'ParvandehKhesarat/checkBimehNamehEnferadiStatus',
  async (query: any) => {
    return await HavadesEnferadiHttpGetService({
      url: `${HadesehApiPath.BimehNamehHadesehEnferadi.BimehNamehHadesehEnferadiSaderShodeh}`,
      params: query,
    });
  }
);

export const createShenasehPardakht = createAsyncThunk(
  'HavadesEnferadi/createShenasehPardakht',
  async (command: any) => {
    return await HavadesEnferadiHttpPostService({
      url: HadesehApiPath.BimehNamehHadesehEnferadi.CreateShenasehPardakht,
      body: command,
    });
  }
);

export const EstelamHadesehEnferadiThunk = createAsyncThunk('Enferadi/Estelam', async (command: any) => {
  return await HavadesEnferadiHttpPostService({
    url: HadesehApiPath.BimehNamehHadesehEnferadi.Estelam,
    body: command,
  });
});

export const GetActivePoosheshHayeHadesehEnferadiThunk = createAsyncThunk(
  'HadesehEnferadi/GetActivePoosheshHayeHadesehEnferadi',
  async () => {
    return await HavadesEnferadiHttpGetService({
      url: HadesehApiPath.PoosheshHadesehEnferadi.GetActivePoosheshHayeHadesehEnferadi,
    });
  }
);

export const getAllShomarehBimehHayeHadesehEnferadi = createAsyncThunk(
  'BimehNamehHadesehEnferadi/GetAllShomarehBimehHayeHadesehEnferadi',
  async () => {
    return await HavadesEnferadiHttpGetService({
      url: `${HadesehApiPath.BimehNamehHadesehEnferadi.GetAllShomarehBimehHayeHadesehEnferadi}`,
    });
  }
);

export const getBimehNamehHadesehEnferadiDetail = createAsyncThunk(
  'BimehNamehEnferadi/GetBimehNamehHadesehEnferadiDetail',
  async (query: any) => {
    return await HavadesEnferadiHttpGetService({
      url: `${HadesehApiPath.BimehNamehHadesehEnferadi.GetBimehNamehHadesehEnferadiDetail}`,
      params: {
        ...query,
      },
    });
  }
);

export const printBimehNamehEnferadi = createAsyncThunk('EnferadiPrint/printBimehNamehEnferadi', async (query: any) => {
  return await HavadesEnferadiHttpGetService({
    url: `${HadesehApiPath.BimehNamehHadesehEnferadi.PrintBimehNamehEnferadi}`,
    params: query,
    responseType: 'blob',
    isFile: true,
  });
});

export const GetAllAnvaeSherkatBimeh = createAsyncThunk('NoeSherkatBimeh/GetAllAnvaeSherkatBimeh', async () => {
  return await BasicInfoHttpGetService({
    url: `${BasicInfoApiPaths.NoeSherkatBimeh.GetAllAnvaeSherkatBimeh}`,
  });
});

export const getActiveKhataratTabiei = createAsyncThunk('KhatarTabiei/getActiveKhataratTabiei', async (query: any) => {
  return await HavadesEnferadiHttpGetService({
    url: `${HadesehApiPath.KhatarTabiei.GetActiveKhataratTabiei}`,
    params: query,
  });
});

export const printBimehNamehHadesehEnferadiById = createAsyncThunk(
  'BimehNamehEnferadi/printBimehNamehHadesehEnferadiById',
  async (query: any) => {
    return await HavadesEnferadiHttpGetService({
      url: `${HadesehApiPath.BimehNamehHadesehEnferadi.PrintBimehNamehHadesehEnferadiById}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);
